import * as React from "react";
import { Navigator } from "./Navigator";
import styles from "./styles.module.scss";
import { FaBars, FaTimes } from "react-icons/fa";
import { ToastContainer } from "react-toastify";
import logo from "../../assets/images/mtn-logo.png";

const CustomNavigation = ({ name, user, page }: any) => {
  const [toggle, setToggle] = React.useState(false);

  return (
    <>
      <ToastContainer />
      <div className={styles.mobileNav}>
        <div className={styles.bars}>
          {toggle ? (
            <FaTimes onClick={() => setToggle(!toggle)} />
          ) : (
            <FaBars onClick={() => setToggle(!toggle)} />
          )}
        </div>
      </div>
      <div
        className={toggle ? styles.mobileNavigation : `${styles.navigation}`}
      >
        <div className={styles.profile}>
          <div className={styles.dp}>
            <img src={logo} alt="DP" />
          </div>
        </div>
        <Navigator name={name} page={page} role={user?.roles} />
      </div>
    </>
  );
};

export default CustomNavigation;
